__webpack_require__.p = "/dev/color-auto-hue/";